export default __webpack_public_path__ + "static/media/bg.27f4051f.jpg";